import React from "react";

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1568150491977-b06e2fdf84cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxhZXN0aGV0aWMlMjBub3RlYm9vayUyMGpvdXJuYWwlMjBjcmVhbSUyMG5ldXRyYWx8ZW58MHx8fHwxNzc3Nzk1NzEyfDA&ixlib=rb-4.1.0&q=85";

const values = [
    {
        title: "Mit Liebe ausgewählt",
        desc: "Jedes Stück durchläuft unsere Hände — mit Geduld, Achtsamkeit und einem Auge fürs Schöne.",
    },
    {
        title: "Sanfte Materialien",
        desc: "Cremefarbenes Papier, weiche Einbände, fein laufende Tinte. Werkzeuge, die das Schreiben verlangsamen.",
    },
    {
        title: "Bedeutungsvolle Geschenke",
        desc: "Worte, die bleiben. Geschenke, die berühren. Kleine Botschaften für besondere Menschen.",
    },
];

export default function About() {
    return (
        <section
            id="geschichte"
            data-testid="about-section"
            className="relative py-24 md:py-32 bg-cream-100"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 md:gap-16 items-center">
                {/* Image */}
                <div className="md:col-span-5 reveal" data-testid="about-image">
                    <div className="img-frame aspect-[4/5]">
                        <img
                            src={ABOUT_IMG}
                            alt="Notizbuch auf weichem Hintergrund"
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>

                {/* Text */}
                <div className="md:col-span-7 reveal">
                    <span
                        className="divider-dot mb-8"
                        data-testid="about-eyebrow"
                    >
                        <span>Unsere Geschichte</span>
                    </span>

                    <h2
                        className="font-serif font-light text-4xl sm:text-5xl text-ink-900 tracking-tight leading-[1.1]"
                        data-testid="about-heading"
                    >
                        Mit Liebe und Sorgfalt
                        <br />
                        <em className="italic text-mauve-500">gemacht.</em>
                    </h2>

                    <p
                        className="mt-8 text-base md:text-lg text-ink-700 leading-relaxed font-light max-w-xl"
                        data-testid="about-paragraph"
                    >
                        Dar al Midad — das „Haus der Tinte" — entstand aus der
                        Liebe zum geschriebenen Wort. Wir glauben, dass schöne
                        Dinge unsere Gedanken verändern. Ein leerer Seitenrand
                        kann eine Einladung sein. Eine sanfte Feder, ein neuer
                        Anfang. Alles, was wir kuratieren, soll diesem Gefühl
                        dienen: still, warm, ehrlich.
                    </p>

                    <div className="mt-12 grid sm:grid-cols-3 gap-8">
                        {values.map((v, i) => (
                            <div
                                key={v.title}
                                data-testid={`about-value-${i}`}
                                className="reveal"
                            >
                                <div className="w-8 h-px bg-mauve-500 mb-4" />
                                <h3 className="font-serif text-xl text-ink-900 mb-2">
                                    {v.title}
                                </h3>
                                <p className="text-sm text-ink-700 leading-relaxed font-light">
                                    {v.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
